import { render } from "./CTA.vue?vue&type=template&id=7efaa1a9&scoped=true"
import script from "./CTA.vue?vue&type=script&lang=js"
export * from "./CTA.vue?vue&type=script&lang=js"

import "./CTA.vue?vue&type=style&index=0&id=7efaa1a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efaa1a9"]])

export default __exports__